export default {
  sharer: {
    shareViaFacebook: 'Compartilhar via Facebook',
    shareViaTwitter: 'Compartilhar via Twitter',
    shareViaPinterest: 'Compartilhar via Pinterest',
    shareViaWhatsapp: 'Compartilhar via Whatsapp',
    shareViaEmail: 'Compartilhar via e-mail'
  }
}
